var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMlService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8,
    fill: "#f77842"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 5,
    fill: "#f77842"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 20,
    r: 5,
    fill: "#f77842"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 42,
    r: 5,
    fill: "#f77842"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42,
    r: 5,
    fill: "#f77842"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 52,
    r: 5,
    fill: "#f77842"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 28L18 23M38 28L46 23M26 36L17 40M38 36L47 40M32 40V47",
    stroke: "#f77842",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMlService);
export default __webpack_public_path__ + "static/media/ai-ml-service.067c3b2e0c08cb69419dfcfe10837da5.svg";
export { ForwardRef as ReactComponent };